import React from 'react';
import './HouseDesign.css';
import useScrollToTop from '../components/useScrollToTop'; // Create this CSS file
import ReusableLanding from '../components/ReusableLanding';
import image2 from '../img/interior.avif';
import img from '../img/living_room_img_3.avif';
import img2 from '../img/living_room_img_1.avif';
import img3 from '../img/room_img_1.avif';
import img4 from '../img/room_img_2.avif';
import img5 from '../img/room_img_3.avif';
import img6 from '../img/room_img_4.avif';
import img7 from '../img/living_room_img_2.avif';
import img8 from '../img/living_room_img_2.avif';
import DesignGallery from '../components/PreGallery';
import GetQuoteForm from  '../components/GetQuoteForm'
import FAQ from '../components/FAQ';
import serviceFAQData from '../components/serviceFAQData';
import { FaMoneyBillWave, FaClock, FaCheckCircle, FaPalette, FaHome, FaTools, FaLightbulb } from 'react-icons/fa'; // Import more icons

//routes
const VILLA_DETAILS_ROUTE = '/ready-designs/modern-villa-details';
const HOUSE_PLANS_ROUTE = '/ready-designs/cozy-family-home';
const southfacing = "/ready-designs/southfacinghousePlan";
const houseplan20x30 ="/ready-designs/houseplan20x30";
const houseplan20x40 ="/ready-designs/houseplan20x40";
const houseplan30x40 ="/ready-designs/houseplan30x40";
const houseplan30x50 ="/ready-designs/houseplan30x50";
const houseplan40x60 ="/ready-designs/houseplan40x60";

const ReadyHouseDesigns = () => {
    useScrollToTop();
    const myDesigns = [
      {
        title: 'Modern Villa Design',
        description: 'A contemporary villa with spacious interiors...',
        layout: '50 X 80 sqft',
        builtArea: '4000 sqft',
        image: img,
        Link:VILLA_DETAILS_ROUTE,
    },
    {
        title: 'Cozy Family Home',
        description: 'A comfortable family home with a garden...',
        layout: '35 X 60 sqft',
        builtArea: '2100 sqft',
        image:img2 ,
        Link: HOUSE_PLANS_ROUTE, // Added a link for the second design
    },
    {
      title: 'SouthFacingHousePlan',
      description: 'South Facing 50x60 2 Storey House Plan: Maximizing Light and Space',
      layout: '50 X 60 sqft',
      builtArea: '3000 sqft',
      image:img3 ,
      Link: southfacing, // Added a link for the second design
  },
  {
    title: '20x30 Feet House Plan',
    description: 'for this plot typically focus on 1 or 2 BHK',
    layout: '20 X 30 sqft',
    builtArea: '600 sqft',
    image:img4 ,
    Link: houseplan20x30, // Added a link for the second design
},
{
  title: '20x40 Feet House Plan',
  description: 'for this plot typically focus on 1 or 2 BHK',
  layout: '20 X 40 sqft',
  builtArea: '800 sqft',
  image:img8 ,
  Link: houseplan20x40, // Added a link for the second design
},
{
  title: '30x40 Feet House Plan',
  description: 'for this plot typically focus on 1 or 2 BHK',
  layout: '30 X 40 sqft',
  builtArea: '1200 sqft',
  image:img5 ,
  Link: houseplan30x40, // Added a link for the second design
},
{
  title: '30x50 Feet House Plan',
  description: 'for this plot typically focus on 1 or 2 BHK',
  layout: '30 X 50 sqft',
  builtArea: '1500 sqft',
  image:img6 ,
  Link: houseplan30x50, // Added a link for the second design
},
{
  title: '40x60 Feet House Plan',
  description: 'for this plot typically focus on 1 or 2 BHK',
  layout: '40 X 60 sqft',
  builtArea: '2400 sqft',
  image:img7 ,
  Link: houseplan40x60, // Added a link for the second design
},

    ];
  return (
    <>
     <ReusableLanding
      imageUrl={image2}
      title="Ready House Designs"
      description="Explore our collection of pre-designed house plans, crafted by experienced architects and designers. These ready-to-build designs offer a perfect blend of style, functionality, and affordability."
    />
    <div className="house-design-page">
    <div className="benefits-section">
  <h2>Benefits of Ready House Designs</h2>
  <p className="benefits-intro">Discover the advantages of choosing our pre-designed house plans, offering a streamlined and efficient path to building your dream home.</p>
  <div className="floor-plan-services-grid">
    <div className="floor-plan-service-item card"> {/* Applying card styling for visual consistency */}
      <div className="service-icon">
        <FaMoneyBillWave />
      </div>
      <h3>Cost-Effective</h3>
      <p>Eliminate significant upfront expenses associated with custom architectural design. Our ready-made plans save you money on design fees and the time involved in the initial conceptualization and drafting stages.</p>
    </div>
    <div className="floor-plan-service-item card"> {/* Applying card styling for visual consistency */}
      <div className="service-icon">
        <FaClock />
      </div>
      <h3>Quick Start</h3>
      <p>Skip the lengthy design process and begin construction almost immediately. Our pre-approved and fully documented plans are ready to go, significantly reducing the timeline from concept to groundbreaking.</p>
    </div>
    <div className="floor-plan-service-item card"> {/* Applying card styling for visual consistency */}
      <div className="service-icon">
        <FaCheckCircle />
      </div>
      <h3>Proven and Refined Designs</h3>
      <p>Benefit from house designs that have been thoughtfully developed, tested, and often built before. This means you're investing in plans with practical layouts and construction considerations already addressed, minimizing potential issues.</p>
    </div>
    <div className="floor-plan-service-item card"> {/* Applying card styling for visual consistency */}
      <div className="service-icon">
        <FaPalette />
      </div>
      <h3>Wide Variety of Styles</h3>
      <p>Explore an extensive collection of architectural styles, including modern minimalist, classic traditional, charming contemporary, rustic farmhouse, and more. Find a design that perfectly matches your aesthetic preferences and lifestyle.</p>
    </div>
    <div className="floor-plan-service-item card"> {/* Applying card styling for visual consistency */}
      <div className="service-icon">
        <FaHome />
      </div>
      <h3>Functional and Livable Layouts</h3>
      <p>Our ready house designs prioritize functionality and comfortable living. They are created with careful consideration of room flow, natural light, storage solutions, and overall usability to enhance your daily life.</p>
    </div>
    <div className="floor-plan-service-item card"> {/* Applying card styling for visual consistency */}
      <div className="service-icon">
        <FaTools />
      </div>
      <h3>Detailed Construction Documents</h3>
      <p>Receive comprehensive construction document sets that include detailed floor plans, elevations, sections, and often material specifications. These documents are essential for accurate bidding, obtaining permits, and guiding your construction team.</p>
    </div>
    <div className="floor-plan-service-item card"> {/* Applying card styling for visual consistency */}
      <div className="service-icon">
        <FaLightbulb />
      </div>
      <h3>Reduced Decision Fatigue</h3>
      <p>Choosing a ready house design can simplify the often overwhelming number of decisions involved in a custom design process. You can focus on personalizing the interior finishes and landscaping rather than the fundamental layout.</p>
    </div>
    {/* You can add even more benefits here */}
  </div>
</div>
      <h2>Our Featured Designs</h2>
      <DesignGallery designs={myDesigns} />

      <section style={{ padding: '0px 20px' }}>
        <h2>How to Purchase</h2>
        <p>
          Browse our catalog, select your preferred design, and contact us to purchase the plans. We offer customization options to tailor the design to your specific needs.
        </p>
      </section>
      <GetQuoteForm/>
      <FAQ faqData= {serviceFAQData}/>
    </div>
    </>
  );
};

export default ReadyHouseDesigns;